import { extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import { withTUXIcon } from './withTUXIcon.js';
import * as React from 'react';

function IconBankCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor"
  }, props, {
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    className: props.className
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 7a4 4 0 00-4 4v26a4 4 0 004 4h32a4 4 0 004-4V11a4 4 0 00-4-4H8zm0 4h32v4.5H8V11zm0 8.5h32V37H8V19.5zM27 30a1 1 0 00-1 1v2a1 1 0 001 1h8a1 1 0 001-1v-2a1 1 0 00-1-1h-8z"
  }));
}
var TUXIconBankCard = withTUXIcon(IconBankCard);

export default IconBankCard;
export { TUXIconBankCard };
